module.exports = __webpack_public_path__ + "img/505.d6186602.jpg";